export const BUSINESS_PROFILE = "BUSINESS_PROFILE";
export const BUSINESS_PROFILE_SUCCESS = "BUSINESS_PROFILE_SUCCESS";
export const BUSINESS_PROFILE_ERROR = "BUSINESS_PROFILE_ERROR";

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_ERROR = "UPDATE_USER_PROFILE_ERROR";
